import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AsBuyer from './AsBuyer'
import { changeStateProp, showSpinner, showModal } from '../../../actions/index'

const mapStateToProps = (state) => {
  return {
    signUpInfo: state.main.signUpInfo,
    locationStates: state.data.locationStates,
    cameFromWpSite: state.user.cameFromWpSite,
    wpSiteName: state.user.wpSiteName,
    buyerAndSellerFormInfo :state.user.buyerAndSellerFormInfo,
    isTermsOpened : state.user.isTermsOpened,
    isPrivacyOpened : state.user.isPrivacyOpened
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ changeStateProp, showSpinner, showModal }, dispatch)
}

const AsBuyerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AsBuyer)

export default AsBuyerContainer
